import webTokenStorer from "../../utils/webStorer"
import { Navigate, Outlet } from "react-router-dom";
import { LOGIN, SOCIETY_CONTROLLER } from "../../Routing/routes";

const SocietyController = () => {
    const getToken = webTokenStorer.getToken2();
    return (
        <>
            {!getToken && <Navigate to={SOCIETY_CONTROLLER + LOGIN} />}
            <Outlet />
        </>
    )
}

export default SocietyController;
